var map = {
	"./3D animation model-filled.svg": "EyoA",
	"./3D animation model-outlined.svg": "ibSl",
	"./API-filled.svg": "LyyN",
	"./API-outlined.svg": "BOL5",
	"./Add outline-outlined.svg": "EiyD",
	"./Add-filled.svg": "yjqX",
	"./Add-outlined.svg": "AGVN",
	"./Airport location-filled.svg": "FGPc",
	"./Airport location-outlined.svg": "LqcM",
	"./Apps-filled.svg": "WYYI",
	"./Apps-outlined.svg": "wwxw",
	"./Arrow-double-left-filled.svg": "7/aG",
	"./Arrow-double-left-outlined.svg": "luvY",
	"./Arrow-double-right-filled.svg": "zTul",
	"./Arrow-double-right-outlined.svg": "3lVQ",
	"./Arrow-down-filled.svg": "2L6l",
	"./Arrow-down-outlined.svg": "6wRq",
	"./Arrow-left-filled.svg": "q1j3",
	"./Arrow-left-outlined.svg": "sCy+",
	"./Arrow-right-filled.svg": "aUqI",
	"./Arrow-right-outlined.svg": "oLQ5",
	"./Arrow-up-filled.svg": "kW5O",
	"./Arrow-up-outlined.svg": "LtuR",
	"./Arrows horizontal 1-filled.svg": "cDpA",
	"./Arrows horizontal 1-outlined.svg": "HPe1",
	"./Arrows horizontal 2-filled.svg": "qXPK",
	"./Arrows horizontal 2-outlined.svg": "GL4R",
	"./Arrows vertical 1-filled.svg": "Ust3",
	"./Arrows vertical 1-outlined.svg": "YKP5",
	"./Arrows vertical 2-filled.svg": "/RFC",
	"./Arrows vertical 2-outlined.svg": "T1D/",
	"./Ascending-filled.svg": "BP/7",
	"./Ascending-outlined.svg": "pwa4",
	"./Asleep-filled.svg": "BGYD",
	"./Asleep-outlined.svg": "iQUY",
	"./Atm-filled.svg": "tKlv",
	"./Atm-outlined.svg": "dVNk",
	"./Attachment-outlined.svg": "DBnt",
	"./Awake-filled.svg": "A1O+",
	"./Awake-outlined.svg": "RZtX",
	"./Blacklist-filled.svg": "CFJX",
	"./Blacklist-outlined.svg": "Js6X",
	"./Bluetooth off-filled.svg": "hBQr",
	"./Bluetooth off-outlined.svg": "7am4",
	"./Bluetooth-filled.svg": "Q+UV",
	"./Bluetooth-outlined.svg": "jPnI",
	"./Bookmark-filled.svg": "1Qwq",
	"./Bookmark-outlined.svg": "JH9L",
	"./Brand management-filled.svg": "/wOQ",
	"./Brand management-outlined.svg": "p0PZ",
	"./Business access-filled.svg": "UaND",
	"./Business access-outlined.svg": "r2Sp",
	"./Business competitor-filled.svg": "o6nk",
	"./Business competitor-outlined.svg": "7Oe5",
	"./Calendar 1-filled.svg": "d6nL",
	"./Calendar 1-outlined.svg": "H+bE",
	"./Calendar 2-filled.svg": "BENZ",
	"./Calendar 2-outlined.svg": "cNym",
	"./Camera-filled.svg": "tx+U",
	"./Camera-outlined.svg": "cDLo",
	"./Caret down-filled.svg": "yN6w",
	"./Caret down-outlined.svg": "h5BY",
	"./Caret left-filled.svg": "/ssl",
	"./Caret left-outlined.svg": "QSUu",
	"./Caret right-filled.svg": "CPZn",
	"./Caret right-outlined.svg": "joIm",
	"./Caret sort-filled.svg": "0nud",
	"./Caret sort-outlined.svg": "oNeh",
	"./Caret up-filled.svg": "PHun",
	"./Caret up-outlined.svg": "dtAB",
	"./Chart bubble-filled.svg": "hT1r",
	"./Chart bubble-outlined.svg": "u56W",
	"./Chart-filled.svg": "xAJy",
	"./Chart-outlined.svg": "XTQM",
	"./Chat-filled.svg": "valB",
	"./Chat-outlined.svg": "5ubK",
	"./Checkmark Origin-outlined.svg": "+PMo",
	"./Checkmark-filled.svg": "2SsO",
	"./Checkmark-outlined.svg": "qa5X",
	"./Chevron down-filled.svg": "5b2M",
	"./Chevron down-outlined.svg": "y4RZ",
	"./Chevron left-filled.svg": "+ZvQ",
	"./Chevron left-outlined.svg": "L8RD",
	"./Chevron right-filled.svg": "hPxa",
	"./Chevron right-outlined.svg": "64V9",
	"./Chevron up-filled.svg": "1gkP",
	"./Chevron up-outlined.svg": "T+5O",
	"./Chocolate-filled.svg": "Hoju",
	"./Chocolate-outlined.svg": "SPz/",
	"./Close-filled.svg": "0Sa/",
	"./Close-outlined.svg": "me1W",
	"./Cloud download-filled.svg": "SqBQ",
	"./Cloud download-outlined.svg": "7AXX",
	"./Cloud upload-filled.svg": "D/Ig",
	"./Cloud upload-outlined.svg": "zgQl",
	"./Code 1-filled.svg": "j4zE",
	"./Code 1-outlined.svg": "/9gb",
	"./Code 2-filled.svg": "qb9a",
	"./Code 2-outlined.svg": "O+r8",
	"./Color palette-filled.svg": "H2lp",
	"./Color palette-outlined.svg": "r3QV",
	"./Color-filled.svg": "2TsS",
	"./Color-outlined.svg": "A/ff",
	"./Commit 1-filled.svg": "9Vhq",
	"./Commit 1-outlined.svg": "y+rG",
	"./Commit 2-filled.svg": "nqgc",
	"./Commit 2-outlined.svg": "SXKG",
	"./Compare-filled.svg": "YmaR",
	"./Compare-outlined.svg": "C9iN",
	"./Computer-filled.svg": "UQNC",
	"./Computer-outlined.svg": "/pnd",
	"./Confirm-filled.svg": "7PgC",
	"./Confirm-outlined.svg": "b3un",
	"./Copy 1-filled.svg": "/6Fs",
	"./Copy 1-outlined.svg": "aYNy",
	"./Copy 2-filled.svg": "tW9k",
	"./Copy 2-outlined.svg": "oBx0",
	"./Creation-filled.svg": "Te8v",
	"./Creation-outlined.svg": "4kwU",
	"./Crop-filled.svg": "SO/c",
	"./Crop-outlined.svg": "+7yp",
	"./Dashboard-filled.svg": "Fu4F",
	"./Dashboard-outlined.svg": "WSq2",
	"./Data-filled.svg": "qKxv",
	"./Data-outlined.svg": "KqA+",
	"./Database addition-filled.svg": "LsuD",
	"./Database addition-outlined.svg": "v1T3",
	"./Database-filled.svg": "dghl",
	"./Database-outlined.svg": "/r/j",
	"./Date package-outlined.svg": "FvKN",
	"./Descending order-filled.svg": "gvSh",
	"./Descending order-outlined.svg": "maiS",
	"./Document add-filled.svg": "mzjy",
	"./Document add-outlined.svg": "vL1/",
	"./Document-filled.svg": "Wljd",
	"./Document-outlined.svg": "JIhw",
	"./Down to bottom-filled.svg": "DGtp",
	"./Down to bottom-outlined.svg": "tfFE",
	"./Download-filled.svg": "QgZM",
	"./Download-outlined.svg": "Jynt",
	"./Drag horizontal-filled.svg": "LcHj",
	"./Drag horizontal-outlined.svg": "OQYr",
	"./Drag vertical-filled.svg": "tgSq",
	"./Drag vertical-outlined.svg": "73S9",
	"./Draggable 1-filled.svg": "9UbZ",
	"./Draggable 1-outlined.svg": "ATXx",
	"./Draggable 2-filled.svg": "4IbS",
	"./Draggable 2-outlined.svg": "j0TB",
	"./EXL-filled.svg": "6H9Q",
	"./EXL-outlined.svg": "SyFP",
	"./Edit off-filled.svg": "K+Ks",
	"./Edit off-outlined.svg": "1p48",
	"./Edit-filled.svg": "KVZA",
	"./Edit-outlined.svg": "OgUT",
	"./Email-filled.svg": "25hN",
	"./Email-outlined.svg": "IrAj",
	"./Enterprise user-filled.svg": "LzZ5",
	"./Enterprise user-outlined.svg": "JwuX",
	"./Equipment-filled.svg": "ci/j",
	"./Equipment-outlined.svg": "+qNF",
	"./Error-filled.svg": "G8rN",
	"./Error-outlined.svg": "k6+l",
	"./Export-filled.svg": "4ycP",
	"./Export-outlined.svg": "n/lU",
	"./Face activated-filled.svg": "bR12",
	"./Face activated-outlined.svg": "yGnF",
	"./Face dissatisfied-filled.svg": "T8ed",
	"./Face dissatisfied-outlined.svg": "mE//",
	"./Favorite-filled.svg": "pEtN",
	"./Favorite-outlined.svg": "4P1Q",
	"./Feedback-filled.svg": "frsl",
	"./Feedback-outlined.svg": "6DLZ",
	"./Filter-filled.svg": "xKa8",
	"./Filter-outlined.svg": "cX53",
	"./Fixed-filled.svg": "/kbD",
	"./Fixed-outlined.svg": "0rxQ",
	"./Flag-filled.svg": "s0Ke",
	"./Flag-outlined.svg": "s4Np",
	"./Folder add-filled.svg": "wsS7",
	"./Folder add-outlined.svg": "VKKJ",
	"./Folder-filled.svg": "wzv1",
	"./Folder-outlined.svg": "rzV6",
	"./Gift-filled.svg": "Kptv",
	"./Gift-outlined.svg": "HedT",
	"./Hamburger-filled.svg": "nir1",
	"./Hamburger-outlined.svg": "P62Q",
	"./Headset-filled.svg": "W8by",
	"./Headset-outlined.svg": "OhWc",
	"./Help-filled.svg": "Otzb",
	"./Help-outlined.svg": "3fsg",
	"./Home-filled.svg": "CCWb",
	"./Home-outlined.svg": "KMLO",
	"./Http-filled.svg": "WDmQ",
	"./Http-outlined.svg": "n3nD",
	"./IP-filled.svg": "L6+x",
	"./IP-outlined.svg": "ypjN",
	"./Idea-filled.svg": "ljvF",
	"./Idea-outlined.svg": "XPZF",
	"./Image damaged-filled.svg": "uNDO",
	"./Image damaged-outlined.svg": "89b9",
	"./Image-filled.svg": "1Pt3",
	"./Image-outlined.svg": "Ifqn",
	"./Information-filled.svg": "v1oe",
	"./Information-outlined.svg": "5Tpu",
	"./Link-filled.svg": "1Zks",
	"./Link-outlined.svg": "IidM",
	"./List-filled.svg": "psTE",
	"./List-outlined.svg": "ypDe",
	"./Location-filled.svg": "5QsM",
	"./Location-outlined.svg": "uvLP",
	"./Locked-filled.svg": "nSeL",
	"./Locked-outlined.svg": "jF5p",
	"./Login-filled.svg": "ccxI",
	"./Login-outlined.svg": "9VIx",
	"./Logout-filled.svg": "Lo/2",
	"./Logout-outlined.svg": "a++x",
	"./Map-filled.svg": "5M+U",
	"./Map-outlined.svg": "T+db",
	"./Maximize-filled.svg": "0Oq3",
	"./Maximize-outlined.svg": "EBoU",
	"./Member management-filled.svg": "/fX6",
	"./Member management-outlined.svg": "fGrC",
	"./Menu-filled.svg": "nxRy",
	"./Menu-outlined.svg": "bjA6",
	"./Minimize-filled.svg": "Auok",
	"./Minimize-outlined.svg": "GRHb",
	"./Misuse-filled.svg": "OQUa",
	"./Misuse-outlined.svg": "r0ye",
	"./Mobile-filled.svg": "HTSE",
	"./Mobile-outlined.svg": "ymts",
	"./Monitoring-filled.svg": "0fv4",
	"./Monitoring-outlined.svg": "W3Fu",
	"./Move-filled.svg": "CB5j",
	"./Move-outlined.svg": "6O71",
	"./NPS-filled.svg": "FXFW",
	"./NPS-outlined.svg": "mF7O",
	"./New 1-filled.svg": "xFEw",
	"./New 1-outlined.svg": "9yXP",
	"./New 2-filled.svg": "Zign",
	"./New 2-outlined.svg": "WTfi",
	"./Notification off-filled.svg": "PYm4",
	"./Notification off-outlined.svg": "IaYO",
	"./Notification-filled.svg": "yh68",
	"./Notification-outlined.svg": "DZ0Q",
	"./Official  proprietary-filled.svg": "t/64",
	"./Official proprietary-outlined.svg": "qxWZ",
	"./Open folder-filled.svg": "0f+i",
	"./Open folder-outlined.svg": "dHCe",
	"./Overflow menu horizontal-filled.svg": "oiie",
	"./Overflow menu horizontal-outlined.svg": "klki",
	"./Overflow menu vertical-filled.svg": "S5Gv",
	"./Overflow menu vertical-outlined.svg": "HBI3",
	"./PDF-filled.svg": "BZ5Z",
	"./PDF-outlined.svg": "WC9p",
	"./PNG-filled.svg": "snjV",
	"./PNG-outlined.svg": "xRyD",
	"./PPT-filled.svg": "YJw+",
	"./PPT-outlined.svg": "Ej+4",
	"./Pack up-filled.svg": "CwKJ",
	"./Pack up-outlined.svg": "PBFm",
	"./Parent child-filled.svg": "9B4J",
	"./Parent child-outlined.svg": "D8+z",
	"./Passenger details-filled.svg": "qNLU",
	"./Passenger details-outlined.svg": "TU0R",
	"./Pause-filled.svg": "/wC/",
	"./Pause-outlined.svg": "QhFy",
	"./Pending-filled.svg": "VOWw",
	"./Pending-outline-outlined.svg": "4tlh",
	"./Pending-outlined.svg": "1OBr",
	"./Phone-filled.svg": "kO8L",
	"./Phone-outlined.svg": "/46N",
	"./Pie chart-filled.svg": "2sNF",
	"./Pie chart-outlined.svg": "03t/",
	"./Play-filled.svg": "NdU9",
	"./Play-outlined.svg": "e1Gx",
	"./Polygon-filled.svg": "Kecy",
	"./Polygon-outlined.svg": "pniQ",
	"./Print-filled.svg": "moHK",
	"./Print-outlined.svg": "11XD",
	"./Processing-filled.svg": "fGnG",
	"./Processing-outlined.svg": "vUMH",
	"./Put away left.svg": "cUzf",
	"./Put away right.svg": "Gzj/",
	"./Put-away-left-outlined.svg": "mc7k",
	"./Put-away-right-outlined.svg": "o5cZ",
	"./QR code-filled.svg": "TnSH",
	"./QR code-outlined.svg": "2CPq",
	"./Query file-filled.svg": "P9AB",
	"./Query file-outlined.svg": "/zQc",
	"./Questionnaire-filled.svg": "drAX",
	"./Questionnaire-outlined.svg": "Eapm",
	"./Random-filled.svg": "EjdC",
	"./Random-outlined.svg": "mOgV",
	"./Recommend tools-outlined.svg": "toEq",
	"./Rectangle-filled.svg": "UgfI",
	"./Rectangle-outlined.svg": "hVa8",
	"./Redo-filled.svg": "4aKA",
	"./Redo-outlined.svg": "ftKv",
	"./Regional thermal-filled.svg": "v3pD",
	"./Regional thermal-outlined.svg": "l7pE",
	"./Remove fixed-filled.svg": "cjP8",
	"./Remove fixed-outlined.svg": "Ndtr",
	"./Renew-filled.svg": "A7fX",
	"./Renew-outlined.svg": "3TeF",
	"./Robot-filled.svg": "Xuoa",
	"./Robot-outlined.svg": "B8w9",
	"./Ruler alt-filled.svg": "8KHC",
	"./Ruler alt-outlined.svg": "ux/s",
	"./Ruler-filled.svg": "8XXj",
	"./Ruler-outlined.svg": "HrTY",
	"./Save-filled.svg": "TdmF",
	"./Save-outlined.svg": "p0Kw",
	"./Scanning-filled.svg": "d9W9",
	"./Scanning-outlined.svg": "1VEE",
	"./Search-filled.svg": "f4Zy",
	"./Search-outlined.svg": "7N5k",
	"./Security-filled.svg": "2mhq",
	"./Security-outlined.svg": "EeV8",
	"./Send-filled.svg": "nRFn",
	"./Send-outlined.svg": "/Z3Q",
	"./Settings adjust-filled.svg": "EtLI",
	"./Settings adjust-outlined.svg": "4gp6",
	"./Settings-filled.svg": "s+Eu",
	"./Settings-outlined.svg": "m5Q3",
	"./Share-filled.svg": "ZmFy",
	"./Share-outlined.svg": "Eir6",
	"./Shopping cart-filled.svg": "CmCa",
	"./Shopping cart-outlined.svg": "WmWX",
	"./Shrink-filled.svg": "11Iz",
	"./Shrink-outlined.svg": "wvmW",
	"./Slash-outlined.svg": "C8Sf",
	"./Star-filled.svg": "JaOK",
	"./Star-outlined.svg": "Sxlw",
	"./Stop-filled.svg": "mTNc",
	"./Stop-outlined.svg": "Rut3",
	"./Store management-filled.svg": "4H0E",
	"./Store management-outlined.svg": "i4kS",
	"./Subtract-filled.svg": "EAsq",
	"./Subtract-outlined.svg": "3dPn",
	"./Supervision-filled.svg": "FE6T",
	"./Supervision-outlined.svg": "XvO/",
	"./Telescope-filled.svg": "xf+k",
	"./Telescope-outlined.svg": "Ryoe",
	"./Text-outlined.svg": "G9MM",
	"./Third party-filled.svg": "ZbgA",
	"./Third party-outlined.svg": "vigT",
	"./Thumbnail-filled.svg": "i9em",
	"./Thumbnail-outlined.svg": "y9Pc",
	"./Thumbs up-filled.svg": "Kz4f",
	"./Thumbs up-outlined.svg": "TTet",
	"./Thumbs-down-filled.svg": "+894",
	"./Thumbs-down.svg": "WJY+",
	"./Time-filled.svg": "y2L9",
	"./Time-outlined.svg": "Z6xd",
	"./Traffic statistics-filled.svg": "FVX5",
	"./Traffic statistics-outlined.svg": "EQ2q",
	"./Trash can-filled.svg": "WgGF",
	"./Trash can-outlined.svg": "g/cF",
	"./Undo-filled.svg": "48+v",
	"./Undo-outlined.svg": "DSIr",
	"./Unfold-filled.svg": "GzQA",
	"./Unfold-outlined.svg": "TJ9H",
	"./Unfolded-filled.svg": "FyMS",
	"./Unfolded-outlined.svg": "63Sa",
	"./Unlink-filled.svg": "9Vqn",
	"./Unlink-outlined.svg": "Qkt9",
	"./Unlocked-filled.svg": "T1ka",
	"./Unlocked-outlined.svg": "lEuS",
	"./Up to top-filled.svg": "BcpE",
	"./Up to top-outlined.svg": "EQq7",
	"./Upgrade-filled.svg": "Kc/L",
	"./Upgrade-outlined.svg": "cI3k",
	"./Upload-filled.svg": "migV",
	"./Upload-outlined.svg": "T2hz",
	"./Use a line separating-filled.svg": "tqIM",
	"./Use a line separating-outlined.svg": "Lyh1",
	"./User admin-filled.svg": "WmLl",
	"./User admin-outlined.svg": "0Od5",
	"./User certification-filled.svg": "r5DP",
	"./User certification-outlined.svg": "OzUb",
	"./User follow-filled.svg": "7ogS",
	"./User follow-outlined.svg": "AY+3",
	"./User management-filled.svg": "uoyD",
	"./User management-outlined.svg": "DoKt",
	"./User multiple-filled.svg": "Zbp5",
	"./User multiple-outlined.svg": "8UnJ",
	"./User-filled.svg": "4fR/",
	"./User-outlined.svg": "/N45",
	"./Video file-filled.svg": "pbT3",
	"./Video file-outlined.svg": "AAJL",
	"./View agenda-filled.svg": "zrtZ",
	"./View agenda-outlined.svg": "sy56",
	"./View carousel-filled.svg": "9m0+",
	"./View carousel-outlined.svg": "HFZT",
	"./View column-filled.svg": "WMaw",
	"./View column-outlined.svg": "xo+O",
	"./View module-filled.svg": "Wk/a",
	"./View module-outlined.svg": "Krlv",
	"./View off-filled.svg": "m+Zp",
	"./View off-outlined.svg": "w5I5",
	"./View-filled.svg": "wmTK",
	"./View-outlined.svg": "pgBR",
	"./Volume down-filled.svg": "vqNe",
	"./Volume down-outlined.svg": "R56t",
	"./Volume mute-filled.svg": "gF/a",
	"./Volume mute-outlined.svg": "SdFj",
	"./Volume up-filled.svg": "ecq7",
	"./Volume up-outlined.svg": "QPtv",
	"./WIFI-outlined.svg": "W4gK",
	"./WORD-filled.svg": "LLK4",
	"./WORD-outlined.svg": "SIWw",
	"./Warning-filled.svg": "y3xX",
	"./Warning-outlined.svg": "wZzQ",
	"./Wikis-outlined.svg": "tO6E",
	"./Withdraw-filled.svg": "IUts",
	"./Withdraw-outlined.svg": "Ihw1",
	"./XLS-filled.svg": "pgxH",
	"./XLS-outlined.svg": "7o2T",
	"./ZIP-filled.svg": "tIVw",
	"./ZIP-outlined.svg": "AMHY",
	"./Zoom in-filled.svg": "Gt0g",
	"./Zoom in-outlined.svg": "OgIE",
	"./Zoom out-filled.svg": "boxq",
	"./Zoom out-outlined.svg": "2PhG",
	"./alipay.svg": "TpyO",
	"./back.svg": "MSJp",
	"./black-face.svg": "5XWT",
	"./di.svg": "XjFp",
	"./home.svg": "GU1v",
	"./home2.svg": "qiOA",
	"./hot.svg": "Cxyb",
	"./i.svg": "SkHj",
	"./icon_announcement.svg": "57a7",
	"./icon_anquan.svg": "Ltzn",
	"./icon_goods_show.svg": "k7Nw",
	"./icon_information.svg": "jSn2",
	"./icon_jisu.svg": "NOiG",
	"./icon_pricechange.svg": "7poz",
	"./icon_shouhou.svg": "7RsW",
	"./icon_zheng.svg": "Opi4",
	"./img_putong_1.svg": "hJym",
	"./img_putong_2.svg": "/xfv",
	"./img_putong_3.svg": "L5MV",
	"./img_putong_4.svg": "lVkw",
	"./img_putong_5.svg": "cY/O",
	"./img_putong_6.svg": "5+YI",
	"./img_putong_7.svg": "ePQ0",
	"./img_putong_8.svg": "CmQA",
	"./laba.svg": "CcKs",
	"./login_icon_ali.svg": "MQhs",
	"./login_icon_bd.svg": "bCqV",
	"./login_icon_dy.svg": "yfWk",
	"./login_icon_ems.svg": "vH+d",
	"./login_icon_jdx.svg": "iOJv",
	"./login_icon_qq.svg": "L9pc",
	"./login_icon_sms.svg": "wpHT",
	"./login_icon_tb.svg": "V/ox",
	"./login_icon_wb.svg": "9mHS",
	"./login_icon_weixin.svg": "dtbk",
	"./new.svg": "JQMR",
	"./new2.svg": "AGLl",
	"./no-stop.svg": "3YkN",
	"./no.svg": "2UpI",
	"./notice.svg": "rhhq",
	"./o.svg": "E0hn",
	"./ok.svg": "vQ8m",
	"./ok1.svg": "Luuz",
	"./order.svg": "yFCU",
	"./person.svg": "vxuN",
	"./qr.svg": "X4Qv",
	"./reshow.svg": "wffJ",
	"./sale30.svg": "jM1m",
	"./sale50.svg": "rrBn",
	"./sale80.svg": "FUnT",
	"./sale90.svg": "LTyR",
	"./shou_chs.svg": "RVxE",
	"./sold.svg": "dwsc",
	"./soldout.svg": "AyCH",
	"./stop.svg": "3LTH",
	"./success.svg": "TBqF",
	"./tobottom.svg": "GMhT",
	"./toleft.svg": "92wW",
	"./top.svg": "aoJj",
	"./toright.svg": "TOoG",
	"./totop.svg": "F9jj",
	"./vip.svg": "x9ib",
	"./wifi.svg": "vM4y",
	"./wx.svg": "jHJp",
	"./x-outline.svg": "AUg+",
	"./x.svg": "HZo+",
	"./xi.svg": "Wj0q",
	"./y.svg": "qKPf",
	"./yooxi-logo-chz.svg": "hobP",
	"./yooxi-logo-outline.svg": "3VYc",
	"./yooxi-logo-updown.svg": "KYnL",
	"./yooxi.svg": "8krL",
	"./yooxi_web.svg": "+8WW",
	"./you.svg": "mNwD",
	"./zuji.svg": "9wk2"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c+w5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg ^\.\/.*\.svg$
// module id = c+w5
// module chunks = 75